<template>
    <div class="placeholder">
        <div v-if="loaded===true" class="main mobile-top-margin" >  
            <div class="container order-first" v-bind:class="winners.length>0 ? '' : 'temp'">
                <div class="row margin-mobile">
                    <div class="my-row"> 
                        <div class="title last">
                            <img ref="trophy" alt="Trophy Raffle" class="iconbig" src="../assets/icons/icons8-trophy-100.png">Raffle # {{ raffleN ? raffleN : "..." }}
                        </div>
                        <!-- tickets sold -->
                        <div class="my-col">
                            <img ref="ticketsref" alt="tickets" class="icon" src="../assets/icons/icons8-two-tickets-100.png"><span class="description text-wrapper"><div>Tickets Sold:&nbsp;</div><div><b>{{ tickets ? tickets : "..." }}</b></div></span>
                        </div>
                        <!-- prize pool-->
                        <div class="my-col">
                            <img alt="prize pool" ref="pool" class="icon" src="../assets/icons/icons8-money-box-100.png"><span class="text-wrapper description"><div>Prize Pool:&nbsp;</div><div><b>{{ pool ? pool : "..." }} SHUF</b></div></span>
                        </div>
                        <!-- time remaining-->
                        <div class="my-col">             
                            <span v-if="time.seconds!=-1" class="flexbox">
                                <img alt="time remaining" ref="hourglass" class="icon" src="../assets/icons/icons8-sand-watch-100.png"><span class="text-wrapper description"><div>Time remaining:</div></span>
                            </span>
                            <span v-else class="flexbox" >
                                <img v-on:appear="animate_icon" alt="time's up"  ref="timeup" class="icon" src="../assets/icons/icons8-box-important-100.png"><span class="text-wrapper description"><div><b>Time's up!</b></div></span>
                            </span>
                        </div>
                        <!-- time counter-->
                        <div class="my-col">
                            <img v-if="time.seconds!=-1" alt="time" class="icon" ref="time" src="../assets/icons/icons8-present-100.png">
                            <ul class="description list text-wrapper" >
                                <div class="row ">
                                    <div class="col timer">
                                        <li v-for="(value, key) in time" v-bind:key="'A'+ key" >
                                            <span v-if="value!=-1">
                                                <b>{{value}}</b>
                                            </span>
                                        </li>
                                    </div>
                                    <div class="col timer-key">
                                        <li v-for="(value, key) in time" v-bind:key="'B'+ key" >
                                            <span v-if="value!=-1">
                                                &nbsp;{{key}}
                                            </span>
                                        </li>
                                    </div>
                                </div>
                                <span v-if="time.seconds==-1 && tickets>mintickets" ref="reward" class="flexbox">
                                    <img alt="reward shuf pick winner" class="icon" src="../assets/icons/icons8-sales-performance-100.png"><span class="text-wrapper description"><div>Get rewarded to pick a winner!</div></span>
                                </span>
                                <span v-if="time.seconds==-1 && tickets<=mintickets" ref="extended" class="flexbox">
                                    <img alt="Raffle extended" class="icon" src="../assets/icons/icons8-realtime-100.png"><span class="text-wrapper description"><div>Raffle extended!</div></span>
                                </span>
                            </ul>
                        </div>     
                    </div>
                </div>
            </div>
            <div v-if="winners.length>0" class="last order-last order-md-first auto mobile-top-margin winner-wrapper" >
                <div v-for="itemtx in winners.slice(0, winnerslength)" v-bind:key="itemtx.tx" class="winner">
                    <button v-on:click="click_winner(itemtx)" class="btn btn-outline-warning winner-button">
                        <b>{{ itemtx.address_short }}</b><br/>
                        wins <b>{{ itemtx.amount }}</b> SHUF
                    </button>
                </div>  
             </div>
        </div>
        <img ref="splash" alt="reward shuf pick winner" class="loadicon" src="../assets/hat-logo-transparent.png"> 
    </div>
</template>

<script>
import {readWeb32socket, getRaffleDapp } from '../web3.js';
import Velocity from 'velocity-animate';
const fetch_interval = 30000;
export default {
    name: 'Stats',
    data: function(){
        return {
            raffleN: this.raffleN,
            tickets: this.tickets,
            mintickets: this.mintickets,
            pickerreward: this.pickerreward,
            pool: this.pool,
            time: {
                days : 0,
                hours:0,
                minutes:0,
                seconds :0,
            } ,
            winners:this.winners,
            winnerslength: this.winnerslength,
            loaded:this.loaded,
        };
    },


    created: async function() {
        this.last_win_block=0;
        this.last_tic_block=0;
        this.winnerslength=1;
        // if infura not enough enable these ^ lines + import above
        // and comment below
        this.RaffleDapp = getRaffleDapp(readWeb32socket());
        this.RaffleDappSoc = this.RaffleDapp;

        this.calculatewinnerslength();
        await Promise.all([this.get_winners(), this.populate_stats()]) 
        this.time_load();    
        this.subscribe_winner();
        this.subscribe_ticket();       
        window.addEventListener('resize', this.calculatewinnerslength);
    },

    mounted() {
        this.$root.$on('winner_interact', data => {
            if(data.blockNumber != this.last_win_block){
                    this.populate_stats();
                    this.get_winners();
                    this.animate_icon(this.$refs.trophy);
                this.last_win_block=data.blockNumber;
            }
        }),

        this.$root.$on('ticket_interact', data => {
        if(data.blockNumber != this.last_tic_block){
                this.populate_stats();
                this.animate_icon(this.$refs.ticketsref);
                this.animate_icon(this.$refs.pool);
                this.last_tic_block=data.blockNumber;
            }
        });
    },
    methods: {
       time_load: function (){
           this.$refs.splash.style.display = 'none';  
           this.loaded=true;
        },

        animate_icon: function animate_icon(el) {
        var pos = 'rotateZ(-0deg)';
        for (let i = 0; i < 3; i++) {
        var new_pos = (pos=="rotateZ(-20deg)")?"rotateZ(20deg)":"rotateZ(-20deg)";
          el.velocity({transform: [new_pos, pos]}, {
            delay: 0,
            duration:100
          })
          pos = new_pos;
        }
        new_pos = 'rotateZ(-0deg)';
            el.velocity({transform: [new_pos, pos]}, {
                delay: 0,
                duration: 100
            })
        },

        calculatewinnerslength(){
          this.winnerslength= window.innerWidth/290;
        },

        populate_stats:async function() {
            let Stats = await this.RaffleDapp.methods.Stats().call();
            this.raffleN = Stats[0].toString();
            this.tickets = Stats[1].toString();
            this.mintickets= (parseFloat(Stats[7].toString())).toString();//this.mintickets= (parseFloat(Stats[7].toString())+1).toString();
            this.pickerreward= formatAmount(parseFloat(Stats[6].toString()) / 10 ** 18);
            this.pool = formatAmount(Math.ceil(parseFloat(Stats[2].toString()) / 10 ** 18));        
            const nextraffleepoch = Stats[3];
            const preserve = Stats[12];
           // const nextraffleepoch =1573934718;
            clearTimeout(this.setup_clock_timeout);
            this.setup_clock(nextraffleepoch);
            this.$root.$emit('totaltickets', this.tickets);
            this.$root.$emit('mintickets', this.mintickets);
            this.$root.$emit('pickerreward', this.pickerreward);
            this.$root.$emit('preserve', preserve);
        },

        subscribe_winner:async function() {
            this.RaffleDappSoc.once('Winner', {fromBlock: 'latest'},  function(error, event){
                if (error) {
                    console.log(error);
                } else {
                    if(event.blockNumber != this.last_win_block){
                        this.$root.$emit('winner_stats', event);
                        this.populate_stats();                 
                        this.animate_icon(this.$refs.trophy);
                        this.last_win_block=event.blockNumber;
                        this.get_winners();     
                    }
                }
            }.bind(this));
        },

        subscribe_ticket:async function() {
            this.RaffleDappSoc.once('Ticket', {fromBlock: 'latest'}, function(error, event){
                    if (error) {
                        console.log(error);
                    } else {
                        if(event.blockNumber != this.last_tic_block) {
                            this.$root.$emit('ticket_stats', event);
                            this.populate_stats();
                            this.animate_icon(this.$refs.ticketsref);
                            this.animate_icon(this.$refs.pool);
                            this.last_tic_block=event.blockNumber;
                        }
                    }
            }.bind(this));
        },

        setup_clock: function setup_clock(nextraffleepoch){
            clearTimeout(this.tick_clock_timeout);
            this.tick_clock(nextraffleepoch);
            this.setup_clock_timeout = setTimeout(this.setup_clock, fetch_interval,nextraffleepoch);
        },

        tick_clock: function tick_clock(currentepoch){
            this.time= return_time(currentepoch);
                if(this.time.seconds==-1 && parseFloat(this.tickets)>parseFloat(this.mintickets)){
                    this.$root.$emit('timesup');
                }
            this.tick_clock_timeout = setTimeout(this.tick_clock, 1000,currentepoch);
        },

        get_winners: async function() {
            this.winners= [];
            this.RaffleDapp.events.Winner({
                fromBlock: 6578509
            }, (error, event) => {
                    if (this.winners.length >8) {
                    this.winners.pop();
                }
                if (event) {
                    this.winners.unshift({
                    address_short: shortAddress(event.returnValues.addr),
                    amount: formatAmount(parseFloat(event.returnValues.amount.toString()) / 10 ** 18),
                    //raffle: event.returnValues.raffle,
                    tx: event.transactionHash
                    });
                }   
            })
        },

        click_winner: function(item) {
            var redirectWindow = window.open(`https://etherscan.io/tx/${item.tx}`, '_blank');
            redirectWindow.location;
        },
    }
}


function return_time(nextraffleepoch){
    var now = new Date().getTime();
    // Find the distance between now and the count down date
    var distance = nextraffleepoch*1000 - now;
    var days = Math.floor(distance / (1000 * 60 * 60 * 24)),
    hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
    minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
    seconds = Math.floor((distance % (1000 * 60)) / 1000),
    pad = function(n){ return (n < 10 && n!=-1) ? '0' + n : n; };

    if (days <= 0) days=-1;
    if (days <= 0 && hours<=0) hours=-1;
    if (days <= 0 && hours<=0 && minutes<=0) minutes=-1;
    if (days <= 0 && hours<=0 && minutes<=0 && seconds<=0) seconds=-1;
    return { days: days, hours: pad(hours), minutes: pad(minutes), seconds: pad(seconds) };
}

function formatAmount(amount, maxDigits = 6)  {
    if (amount.toString().length <= maxDigits) {
        return amount.toString();
    }
    const intDigits = amount.toFixed(0).toString().length;
    const decDigits = maxDigits - intDigits;
    const decimals = (decDigits > 0) ? decDigits : 0;
    return Number(amount.toFixed(decimals)).toString();
}

function shortAddress(addr) {
    return `${addr.slice(0, 5)}...${addr.slice(-5)}`;
}

</script>

<style scoped>

.iconbig{
    width:60px;
    margin-right:20px;
}
.placeholder{
    display:flex;
    min-height: 515px;
    justify-content: center;
    align-items: center;
}
.loadicon{
    max-width:80%;
    max-height: 200px;
    opacity: 0.3;
}
.icon{
    width:45px;
    margin-right:15px;
}
.winner {
    margin: 20px;
    display: inline-block;
}
.winner-wrapper{
    flex: 0 1;
    overflow-x:hidden;
    overflow-y: hidden;
    white-space: nowrap;
    width:100%;
    padding-bottom: 10px;
}  
.container{
    display: flex;
    justify-content: center;
    align-self: flex-start;
    flex-grow: 1;
    max-height: 403px;
}
.main{
    display: flex;
    flex-flow:column nowrap;
    align-items:center;
    align-content: center;
    overflow-x:hidden;
    min-height: 515px;
}
.my-row{
    height: 100%;
    max-width: 700px;
    margin:auto;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    align-content:space-around;
    flex-grow: 1;
    padding-top: 40px; 
    padding-bottom:10px;
}
.my-col{
    flex: 0 1 350px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    margin: 10px auto 10px auto;
    padding:10px;   
}
.flexbox{
    flex: 0 1 350px;
    margin:auto;
    padding:0px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
}
.text-wrapper{
    display: flex;
    flex-flow: row wrap;
}
ul{
    margin-bottom: 0px;
}
.list{
    list-style-type: none;
    padding-inline-start: 0px;
}
.last {
    min-width: 320px;
}
.timer{
    display:inline-block;
    text-align: center;
    min-width: 65px;
    padding-left: 5px;
    padding-right: 5px;
}
.timer-key{
    text-align: left;
    padding-left: 5px;
    padding-right: 5px;
}
.winner-button {
    color: #dba80d;
    border-color: #dba80d;
    width: 250px;
}
.winner-button:hover {
    color: white;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.auto{
    margin: auto;
}
.title{
    flex: 0 1 900px;
    position: static;
    height: 70px;
    text-align: center !important;
    font-weight: 600;
    font-size: 35px;
    line-height: 93.19%;
    text-align: left;
    display: block;
    align-items: center;
    letter-spacing: -0.02em;
    color: #000000;
}
.description{
    font-size: 25px;
    text-align: left;
    color: #000000;
}
.temp{
    margin-top:40px !important; 
} 

@media screen and (max-width: 767px) {
    .hide-mobile {
        display: none;
    }
    .margin-mobile {
        margin: 2% ;
    }
    /* .mobile-top-margin {
        margin-top:50px !important; 
    } */
    .container{
        max-height:unset;
    }
}
@media screen and (max-width: 450px) {
    .text-wrapper{
        justify-content: center;
        text-align: center !important;
        flex: 1 0 250px;
    }
}
</style>